/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AnnuallyConfig } from '../models/AnnuallyConfig';
import { DailyConfig } from '../models/DailyConfig';
import { MonthlyConfig } from '../models/MonthlyConfig';
import { StandardBackupScheduleFrequency } from '../models/StandardBackupScheduleFrequency';
import { StandardIntervalConfig } from '../models/StandardIntervalConfig';
import { WeeklyConfig } from '../models/WeeklyConfig';

export class StandardBackupScheduleConfig {
  'frequency': StandardBackupScheduleFrequency;
  'intervalConfig'?: StandardIntervalConfig | null;
  'dailyConfig'?: DailyConfig | null;
  'weeklyConfig'?: WeeklyConfig | null;
  'monthlyConfig'?: MonthlyConfig | null;
  'annuallyConfig'?: AnnuallyConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "frequency",
      "baseName": "frequency",
      "type": "StandardBackupScheduleFrequency",
      "format": ""
    },
    {
      "name": "intervalConfig",
      "baseName": "intervalConfig",
      "type": "StandardIntervalConfig",
      "format": ""
    },
    {
      "name": "dailyConfig",
      "baseName": "dailyConfig",
      "type": "DailyConfig",
      "format": ""
    },
    {
      "name": "weeklyConfig",
      "baseName": "weeklyConfig",
      "type": "WeeklyConfig",
      "format": ""
    },
    {
      "name": "monthlyConfig",
      "baseName": "monthlyConfig",
      "type": "MonthlyConfig",
      "format": ""
    },
    {
      "name": "annuallyConfig",
      "baseName": "annuallyConfig",
      "type": "AnnuallyConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StandardBackupScheduleConfig.attributeTypeMap;
  }

  public constructor() {
  }
}



